/**
 * Design System - Spacing Tokens
 * Defines spacing, padding, margin, and gaps across the design system
 */

export const spacing = {
  // Base unit: 4px
  xs: '4px',
  sm: '8px',
  md: '12px',
  base: '16px',
  lg: '20px',
  xl: '24px',
  xl2: '28px',
  xl3: '32px',
  xl4: '36px',
  xl5: '40px',
  xl6: '48px',
  xl7: '56px',
  xl8: '64px',
  xl9: '72px',
  xl10: '80px',

  // Aliases for semantic usage
  none: '0',
  gapSmall: '8px',
  gapBase: '16px',
  gapMedium: '20px',
  gapLarge: '24px',
  gapXLarge: '32px',

  // Padding presets
  paddingXSmall: '4px 8px',
  paddingSmall: '8px 12px',
  paddingBase: '12px 16px',
  paddingMedium: '16px 20px',
  paddingLarge: '20px 24px',
  paddingXLarge: '24px 32px',

  // Common container paddings
  containerPaddingMobile: '12px',
  containerPaddingTablet: '16px',
  containerPaddingDesktop: '24px',
};

/**
 * Breakpoints for responsive design
 */
export const breakpoints = {
  mobile: '480px',
  tablet: '768px',
  desktop: '1024px',
  wide: '1440px',
  ultraWide: '1920px',
};

/**
 * Z-index scale for layering
 */
export const zIndex = {
  hide: -1,
  auto: 'auto',
  base: 0,
  dropdown: 100,
  sticky: 200,
  fixed: 300,
  modal: 400,
  popover: 500,
  tooltip: 600,
  notification: 700,
  loading: 800,
};
